let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gmdLX")).then(() => parcelRequire('cF55v'));